import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.ResponsiveBackground = class ResponsiveBackground extends Snappy.BaseComponent {
    static get tagName() {
        return 'responsive-background';
    }

    constructor(element) {
        super(element);
    }

    setOptions() {
        this.Options = {
            images: this.$element.data('images'),
        }
        this.images = this.Options.images.split(',');
    }

    setEventListeners() {
        window.addEventListener('resize', this.loadImage.bind(this));
    }

    loadImage() {
        if ($(window).width() <= 360) {
            this.$element.css("background-image", "url("+this.images[0]+")");
        }
        else if ($(window).width() <= 670 && $(window).width() > 361) {
            this.$element.css("background-image", "url(" + this.images[1] + ")");
        }
        else if ($(window).width() <= 1080 && $(window).width() > 669) {
            this.$element.css("background-image", "url(" + this.images[2] + ")");
        }
        else if ($(window).width() >= 1081) {
            this.$element.css("background-image", "url(" + this.images[3] + ")");
        }

    }

    render() {
        this.setOptions();
        this.loadImage();
        this.setEventListeners();
    }



}






// WEBPACK FOOTER //
// ./components/responsive-background/scripts/_responsive-background.js